import React from 'react';
import { CategoryButton } from './ui/button';

export default function MainCategories({ categories = [], activeCategory, onSelectCategory }) {
  // Add "All" option
  const allCategories = [{ id: null, name: 'All' }, ...categories];

  const handleCategoryClick = (catId) => {
    if (catId === null) {
      onSelectCategory(null);
    } else if (activeCategory === catId) {
      onSelectCategory(null);
    } else {
      onSelectCategory(catId);
    }
  };

  return (
    <div className="w-full flex justify-center mt-4 mb-4 px-4 md:px-6">
      <div className="w-full max-w-[1140px]">
        <div
          className="w-full rounded-xl flex flex-wrap items-center gap-4 px-5 py-4"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.02)',
            border: '1px solid rgba(255, 255, 255, 0.16)',
            boxShadow: 'inset 0px -4px 48px -24px rgba(255, 0, 167, 0.32)',
            backdropFilter: 'blur(32px)',
          }}
        >
          {allCategories.map((cat) => {
            const isActive = cat.id === null
              ? activeCategory === null
              : activeCategory === cat.id;

            return (
              <CategoryButton
                type="main"
                key={cat.id || 'all'}
                active={isActive}
                icon={cat.id ? cat.icon : null}
                onClick={() => handleCategoryClick(cat.id)}
              >
                {cat.name}
              </CategoryButton>
            );
          })}
        </div>
      </div>
    </div>
  );
}